import api from "./api";

const asignacionRecursos = {
  listarPuntosServicio() {
    return api.get(`/asignacion-recursos/puntos_servicio`);
  },
  listarRecursos(psObjeto: string) {
    const params = new URLSearchParams();
    params.append('ps_objeto', psObjeto);
    return api.get(`/asignacion-recursos/recursos?${params.toString()}`);
  },
  moverRecursos(payload: { recursos: string[]; ps_origen: string; ps_destino: string }) {
    return api.post(`/asignacion-recursos/mover`, payload);
  },
};

export default asignacionRecursos;
